export const trimTrackingPageUrl = (trackingPageUrl: string) =>
  `${trackingPageUrl.substring(0, 39)}...${trackingPageUrl.substring(trackingPageUrl.length - 4)}`;
